import * as addMonths from 'date-fns/add_months';

import { currency, CurrencyId } from '../models/actualization';


// алиаc валюты, в которой осуществляется поиск и после запрашивается актуализация туров
export const CURRENCY_ALIAS: currency = 'RUB';
export const CURRENCY_ID: CurrencyId = CurrencyId.RUB;

export const MOSCOW_CITY_ID = 832;

export const DEPARTURE_DATES_INTERVAL = 2;
export const MAX_DEPART_DATE = addMonths(new Date(), 18);
export const DEFAULT_ADULTS_COUNT = 2;
export const MAX_ADULTS_COUNT = 6;
export const MAX_KID_AGE = 18;
export const MAX_KID_COUNT = 5;
export const DEFAULT_MIN_TOUR_NIGHTS = 7;
export const DEFAULT_MAX_TOUR_NIGHTS = 8;
export const MAX_NUM_TOUR_NIGHTS = 30;
export const TOUR_NIGHTS_INTERVAL = 2;
export const MAX_NIGHT_RANGE = 10;

export const HOTEL_COMMON_FACILITIES_GROUP_ID = 8;
export const HOTEL_MEALS_FACILITIES_GROUP_ID = 10;
export const FACILITIES_FOR_KIDS_GROUP_ID = 18;

export const BATCH_HOTEL_REVIEWS_SIZE = 4;
export const NUM_TOUR_PACKS_TO_DISPLAY = 10;

// кол-во турпаков, начиная с которого нужно давать возможность использовать пост-фильтры (невключая)
export const MIN_TOURPACKS_FOR_POSTFILTERS = 10;

export const AVERAGE_HUMAN_SPEED = 5; // km
export const AVERAGE_CAR_SPEED = 60; // km

export const PHOTO_GALLERY_WIDTH = 960;
export const PHOTO_GALLERY_HEIGHT = 480;

// отображаем вкладку с фильтрами, если есть хотя бы 2 фильтра
// https://sletathq.slack.com/archives/CC7RQBKC6/p1536581590000100
export const MIN_FILTERS_FOR_VISIBILITY = 2;

export const STICKY_BLOCK_TOP_PADDING = 12;

export const DEFAULT_UNLINKED_ROOM_ID = 0;

export const DEFAULT_IS_ONLINE_BILLING = true;
